import template from './advertAddPage.html';
import controller from './advertAddPage.controller';
import './advertAddPage.scss';

let advertAddPageComponent = {
  restrict: 'E',
  bindings: {
    linkTypes: '<',
    racedays: '<',
    advert: '<',
    socialMediaCategories: '<',
    locations: '<',
    nonRacingEvents: '<'
  },
  template,
  controller
};

export default advertAddPageComponent;
